import { BarChartOut, usageRevenueByUser, UsageRevenueByUserData, UsageQuery } from "@/api";
import { appState } from "@/app/appState";
import { barTable, ChartState, LabelFor } from "../table";
import { useUsageChart } from "../useUsageChart";
import { userRowLabel } from "../views";

const usageTypeLabel: LabelFor = (item) => appState.t(`usage.type.${item.key}`);

/**
 * Predicted revenue per user: billable LLM usage of paying organisations
 * times the billing markup, split by usage type. POST /usage/charts/revenue-by-user
 */
export const useRevenueByUserChart = (query: UsageQuery | undefined): ChartState => {
    const { data, loading, failed } = useUsageChart<UsageRevenueByUserData, BarChartOut>(usageRevenueByUser, query);
    return {
        key: "revenue-by-user",
        title: appState.t("usage.group.revenue"),
        loading,
        failed,
        hint: appState.t("usage.revenueHint"),
        table:
            data &&
            barTable(data, {
                rowLabel: appState.t("usage.user"),
                rowLabelFor: userRowLabel,
                columnLabelFor: usageTypeLabel,
            }),
    };
};
